import { render, staticRenderFns } from "./AnimatingBTN.vue?vue&type=template&id=68cde332"
import script from "./AnimatingBTN.vue?vue&type=script&lang=js"
export * from "./AnimatingBTN.vue?vue&type=script&lang=js"
import style0 from "./AnimatingBTN.vue?vue&type=style&index=0&id=68cde332&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports